// extracted by mini-css-extract-plugin
export default {"productGallery":"FJ-z","inQuickShop":"GJ-z"};